import { AnyMenuItem, menuItem } from 'base/ui/menu_model';
import { ToastQueue } from 'base/ui/toast';
import { BlocksService } from 'blocks/blocks_service';
import React from 'react';
import { SelectionStore } from '../selection/store';
import { ProjectSession } from '../session/session';
import { AddThread, ClickToAddComment, ToggleAddModeButton } from './adding';
import { CanvasCommentPins } from './canvas';
import {
  NotificationSettings,
  notificationsMenuItem,
} from './notification_settings';
import { CommentingSidebarPanel } from './sidebar_panel';
import { CommentingUiStore } from './ui_store';

export type CommentingExport = {
  overlay: React.ReactNode;
  getSidebarPanel: () => React.ReactNode;
  getViewMenuItem: () => AnyMenuItem;
  getNotificationsMenuItem?: () => AnyMenuItem;
  headerButton: React.ReactNode;
  maybeHandleEscape: () => boolean;
};

export function createCommenting(
  session: ProjectSession,
  blocksService: BlocksService,
  selection: SelectionStore,
  toastQueue: ToastQueue,
): CommentingExport {
  const store = new CommentingUiStore(session, selection);

  return {
    overlay: (
      <>
        <ClickToAddComment store={store} toastQueue={toastQueue} />
        <CanvasCommentPins store={store} toastQueue={toastQueue} />
        <AddThread store={store} />
        <NotificationSettings session={session} blocksService={blocksService} />
      </>
    ),
    getSidebarPanel: () =>
      store.addMode ? (
        <CommentingSidebarPanel store={store} toastQueue={toastQueue} />
      ) : undefined,
    getViewMenuItem: () =>
      menuItem({
        label: 'Comments',
        checked: store.showComments,
        onClick: () =>
          (store.showCommentsPreference = !store.showCommentsPreference),
      }),
    getNotificationsMenuItem: store.loggedIn
      ? () => notificationsMenuItem
      : undefined,
    headerButton: <ToggleAddModeButton store={store} />,
    maybeHandleEscape: () => {
      if (store.selectedThreadId) {
        store.selectedThreadId = undefined;
        return true;
      }
      if (store.addThreadAt) {
        store.addThreadAt = undefined;
        return true;
      }
      if (store.addMode) {
        store.addMode = false;
        return true;
      }
      return false;
    },
  };
}
